<div class="appbased-tv__skip">
  <button tabindex="0"
          class="btn-skip"
          [title]="'global.skipToMainContent' | translate"
          id="skipToContent"
          (click)="skipToMainContent()">{{'global.skipToMainContent' | translate}}</button>
</div>
<div class="appbased-tv__header" id="appBasedTvHeader">
  <div class="row">
    <div class="col-6">
      <picture class="appbased-tv__logo">
        <img src="assets/images/logo-white.png" [alt]="'global.logo.alt' | translate"/>
      </picture>
    </div>
    <div class="col-6">
      <rch-language-toggle *ngIf="showLanguageToggle"></rch-language-toggle>
    </div>
  </div>
</div>